import { Tooltip } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { Functionality } from 'api/userPermissions/userPermissions.enum';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { DeleteScheduleProps } from './DeleteSchedule.types';
import * as Styled from './DeleteSchedule.styles';

export const DeleteSchedule = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
  schedule,
}: DeleteScheduleProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.HARMONOGRAMY]?.edit;

  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isPermsDisabled}
        title={formatMessage({ id: AppMessages['common.noPermissions'] })}
      >
        <Styled.TrashIcon onClick={isPermsDisabled ? undefined : onModalOpen} disabled={isPermsDisabled} />
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['schedule.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <ActionModal.Subtitle>{schedule.nazwa}</ActionModal.Subtitle>
        <ActionModal.Text>{formatMessage({ id: AppMessages['schedule.delete.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
